import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import React from 'react'
import ReactDOM from 'react-dom'
import { HashRouter as Router } from 'react-router-dom'
import * as serviceWorker from './serviceWorker'
import App from './App'
import { AppState } from './state'
import ScrollToTop from 'utils/scroll-to-top'
import './global.scss'

ReactDOM.render(
  <Router>
    <AppState>
      <ScrollToTop>
        <App />
      </ScrollToTop>
    </AppState>
  </Router>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
